/**
 * Runtime config is injected by docker-entrypoint.sh into /env-config.js (window.__ENV__)
 * when the container starts. Falls back to VITE_* from .env for local development.
 */
const runtimeEnv: Record<string, string | undefined> = (typeof window !== "undefined" && window.__ENV__) || {};

const get = (key: string): string => runtimeEnv[key] || (import.meta.env[`VITE_${key}`] as string | undefined) || "";

export const ENV = {
	HOST: get("SERVER_HOST"),
	PORT: get("SERVER_PORT"),
	/** Deployed release, e.g. "v1.0.0" (staging/prod) or "sha-f4e544d" (dev) */
	VERSION: get("VERSION"),
	GOOGLE_MAPS_API_KEY: get("GOOGLE_MAPS_API_KEY"),
	SENTRY_DSN: get("SENTRY_DSN"),
	SENTRY_ENVIRONMENT: get("SENTRY_ENVIRONMENT") || import.meta.env.MODE || "development",
	PUBLIC_REGISTRATION_URL: get("PUBLIC_REGISTRATION_URL"),
	/** Base URL of the institute portal (for links to public course catalog). */
	INSTITUTE_PORTAL_URL: get("INSTITUTE_PORTAL_URL"),
};

// Compose the full URL
export const SERVER_URL = `${ENV.HOST}${ENV.PORT ? `:${ENV.PORT}` : ""}`;
